import React from 'react';
import { useTheme } from '../../../../../theme-context';
import { IFiltersExecutive } from '../../../../../interfaces/excecutive/IFiltersExecutive';
import { ICallAnalytics } from '../../../../../interfaces/excecutive/ICallAnalytics';

const CALL_TRACKING = [
    {
        label: 'Number of Calls',
        sub: 'Nr. of calls for selected period',
        key: 'totalCallsAllocated',
        symbol: '',
    },
	{
		label: 'Total Reservation Confirmed',
		sub: '',
		key: 'totalReservationsConfirmed',
		symbol: '',
	},
	{
        label: 'Containment Rate',
        sub: 'Caller’s needs were met',
        key: 'containmentRate',
        symbol: '%',
    },
	{
        label: 'Booking Rate',
        sub: 'Call ended in a successful booking',
        key: 'bookingRate',
        symbol: '%',
    },
	// {
    //     label: 'Booking Value',
    //     sub: '',
    //     key: 'totalCost',
    //     symbol: '%',
    // },
    {
        label: 'Abandonment Rate',
        sub: 'Calls disconnected by caller before Claire answered',
        key: 'abandonmentRate',
        symbol: '%',
    },
    {
        label: 'Transfer Rate',
        sub: 'Caller was transferred to Agent',
        key: 'transferRate',
        symbol: '%',
    },
    {
        label: 'Booking Failure count',
        sub: 'Reservation flow initiated but call terminated by customer',
        key: 'bookingFailureCount',
        symbol: '',
    },
    {
        label: 'Avg. Duration',
        sub: 'Call duration for selected period',
        key: 'avgDuration',
        symbol: ' sec',
    },
	
];

const getByPath = (obj: any, path: string, fallback = 0) => {
    if (!obj || !path) return fallback;

    return (
        path
            .split('.')
            .reduce(
                (acc, key) =>
                    acc && acc[key] !== undefined ? acc[key] : undefined,
                obj,
            ) ?? fallback
    );
};

const CallTracking = ({
    rightNode,
    title,
	filters,
	analytics
}: {
    rightNode: React.ReactElement;
    title?: string;
	filters: IFiltersExecutive;
	analytics?: ICallAnalytics
}) => {
    const { theme } = useTheme();

    return (
        <div>
            <div className="mt-2 mb-3 flex flex-col md:flex-row flex-wrap md:items-center">
                <h4 className="text-xl font-semibold text-black dark:text-primary-dark mb-1">
                    {title || 'Call tracking'}
                </h4>
                <div className="md:ml-auto flex flex-col md:flex-row no-print">
                    {rightNode}
                </div>
            </div>
            <div className="flex flex-wrap -mx-1">
                {CALL_TRACKING.map((call: any) => (
                    <div
                        key={call.title}
                        className="w-full md:w-6/12 lg:w-3/12 px-1 mb-2">
                        <div
                            key={call.label}
                            className="rounded-2xl border border-slate-200 p-3 lg:p-2 2xl:p-6 dark:bg-[#1F1F1F]"
                            style={{
                                borderColor:
                                    call.color ||
                                    (theme === 'dark'
                                        ? 'transparent'
                                        : '#00330F'),
                            }}>
                            <div className="flex items-center justify-between">
                                <p
                                    className="text-sm 2xl:tracking-wide text-primary font-semibold"
                                    style={{
                                        color:
                                            theme === 'dark'
                                                ? 'white'
                                                : call.color,
                                    }}>
                                    {call.label}
                                </p>
                            </div>
                            <p className="text-[11px] text-gray-800 dark:text-white font-normal min-h-9">
                                {call.sub}
                            </p>
                            <p className="mt-2 text-xl md:text-2xl font-medium text--900 dark:text-white">
                                {/* {analytics?.data?.[0]?.[call.key as EAnalytics] || 0}{call.symbol} */}
                                {((v) =>
                                    Number.isInteger(v) ? v : v.toFixed(2))(
                                    Number(
                                        getByPath(
                                            analytics,
                                            call.key,
                                        ),
                                    ),
                                )}
                                {call.symbol}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CallTracking;
